import { Button } from '@you/ui'
import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useKnowledgeStore } from '@/stores/knowledgeStore'
import { KnowledgeDocType } from '@/api/types/knowledge.types'
import TextDatasetImportFlow from './components/TextDatasetImportFlow'
import TableDatasetImportFlow from './components/TableDatasetImportFlow'

const DatasetImport = () => {
  const navigate = useNavigate()
  const { currentKnowledge, currentDataset } = useKnowledgeStore()

  // 返回按钮
  const handleBack = () => {
    navigate(-1)
  }

  const handleFinish = () => {
    navigate(`/knowledge/dataset-detail?id=${currentDataset?.id}`)
  }

  // 根据知识库类型渲染不同的流程组件
  const renderFlowComponent = () => {
    if (currentKnowledge?.docType === KnowledgeDocType.TEXT) {
      return <TextDatasetImportFlow onFinish={handleFinish} />
    } else if (currentKnowledge?.docType === KnowledgeDocType.TABLE) {
      return <TableDatasetImportFlow onFinish={handleFinish} />
    }
    // 默认返回文本类型
    return <TextDatasetImportFlow onFinish={handleFinish} />
  }

  return (
    <div className="h-full w-full flex flex-col">
      {/* 头部导航区域 */}
      <div className="flex items-center justify-between mb-6 flex-shrink-0 flex-none">
        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleBack}
            className="flex items-center space-x-2 p-0 h-auto"
          >
            <ChevronLeft className="h-6 w-6 text-black" />
          </Button>
          <div className="flex items-center space-x-3">
            <h1 className="text-2xl font-semibold text-black">添加内容</h1>
          </div>
        </div>
      </div>

      {/* 内容区域 */}
      {renderFlowComponent()}
    </div>
  )
}

export default DatasetImport
